import { Text, useResponsiveValue } from 'braid-design-system';
import type { ComponentProps, FC } from 'react';

type TextSize = ComponentProps<typeof Text>['size'];

// This is copied and modified from Braid's useResponsiveValue
type RequiredResponsiveTextSizeObject = Partial<
  Record<'mobile' | 'tablet' | 'desktop' | 'wide', TextSize>
> &
  Record<'mobile', TextSize>;

type ResponsiveTextProps = {
  size: RequiredResponsiveTextSizeObject;
  fallbackSize: TextSize;
} & Omit<ComponentProps<typeof Text>, 'size'>;

export const ResponsiveText: FC<ResponsiveTextProps> = ({
  children,
  size,
  fallbackSize,
  ...restProps
}) => {
  const responsiveSize = useResponsiveValue()<TextSize>(size);

  return (
    <Text size={responsiveSize ?? fallbackSize} {...restProps}>
      {children}
    </Text>
  );
};
